// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { GetAiAgentConfigsCozeAgentsQuery, BaseResponseListSimpleBot } from '../../../types';

/**
 * 查询智能体列表
 *
 * @export
 * @tags Coze智能体
 * @link [GET] /aiAgentConfigs/coze/agents
 */
export function getAiAgentConfigsCozeAgents(
    options: ApiOptions<never, GetAiAgentConfigsCozeAgentsQuery> & {
        params: GetAiAgentConfigsCozeAgentsQuery;
    }
): Promise<BaseResponseListSimpleBot> {
    return request<never, never, GetAiAgentConfigsCozeAgentsQuery>('/aiAgentConfigs/coze/agents', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAiAgentConfigsCozeAgents',
    });
}

export const meta = [{ tags: ['Coze智能体'], path: '/aiAgentConfigs/coze/agents', method: 'get' }];
